import styled from 'styled-components';
import Button from '@/styles/common/Button';
import { defaultStyles } from '@/styles/defaults';

const StyledMoveButton = styled(Button)`
  ${defaultStyles}
  &:active {
    cursor: grabbing;
  }
`;

export default StyledMoveButton;
